import { collection, documentId, getDocs, limit, orderBy, query, startAfter, where } from 'firebase/firestore';
import { db } from '../firebase';

export const getRegistrantEventId = registrant => registrant?.eventId || 'APCS2025';

// Explicit staff action: missing fields cannot be found by equality queries.
// Order by document ID, since old registrations can also lack createdAt.
export async function loadGuestRegistrants(sourceEventId) {
    const registrants = [];
    let cursor;
    while (true) {
        const page = await getDocs(query(collection(db, 'Registrants2025'), orderBy(documentId()),
            ...(cursor ? [startAfter(cursor)] : []), limit(200)));
        registrants.push(...page.docs.map(record => ({ ...record.data(), id: record.id }))
            .filter(registrant => getRegistrantEventId(registrant) === sourceEventId));
        if (page.docs.length < 200) return registrants;
        cursor = page.docs[page.docs.length - 1];
    }
}

// Saved guests load by ID even when the source tab has never been opened.
export async function loadAssignedGuestRegistrants(groups, currentRegistrants) {
    const knownIds = new Set(currentRegistrants.map(registrant => registrant.id));
    const ids = [...new Set(groups.flatMap(group => group.registrantIds || []))].filter(id => !knownIds.has(id));
    const registrants = [];
    for (let index = 0; index < ids.length; index += 30) {
        const page = await getDocs(query(collection(db, 'Registrants2025'),
            where(documentId(), 'in', ids.slice(index, index + 30))));
        registrants.push(...page.docs.map(record => ({ ...record.data(), id: record.id })));
    }
    return registrants;
}
